const Center = require('./Center');
const Child = require('./Child');
const Parent = require('./Parent');
const Seat = require('./Seat');

class Tour {
  constructor() {
    this.init();
  }

  init() {
    this.tour_id = undefined;
    this.center = undefined;
    this.parent = undefined;
    this.parent2 = undefined;
    this.child = undefined;
    this.start_time = undefined;
    this.end_time = undefined;
    this.notes = undefined;
    this.family_notes = undefined;
    this.internal_notes = undefined;
    this.completed = undefined;
    this.confirmed = undefined;
    this.no_show = undefined;
    this.no_show_count = undefined;
    this.virtual = undefined;
    this.virtual_instructions = undefined;
    this.duration = undefined;
    this.deleted_at = undefined;

    // Read-only properties
    this.spot_id = undefined;
    this.seat = undefined;
  }

  copy() {
    const cp = new Tour();

    cp.tour_id = this.tour_id;
    cp.start_time = this.start_time;
    cp.end_time = this.end_time;
    cp.notes = this.notes;
    cp.family_notes = this.family_notes;
    cp.internal_notes = this.internal_notes;
    cp.completed = this.completed;
    cp.confirmed = this.confirmed;
    cp.no_show = this.no_show;
    cp.no_show_count = this.no_show_count;
    cp.spot_id = this.spot_id;
    cp.virtual = this.virtual;
    cp.virtual_instructions = this.virtual_instructions;
    cp.duration = this.duration;
    cp.deleted_at = this.deleted_at;

    if (this.center) {
      cp.center = this.center.copy();
    }
    if (this.child) {
      cp.child = this.child.copy();
    }
    if (this.parent) {
      cp.parent = this.parent.copy();
    }
    if (this.parent2) {
      cp.parent2 = this.parent2.copy();
    }
    if (this.seat) {
      cp.seat = this.seat.copy();
    }

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.tour_id = obj.tour_id ? obj.tour_id.toString() : undefined;
      this.start_time = obj.start_time ? new Date(obj.start_time) : undefined;
      this.end_time = obj.end_time ? new Date(obj.end_time) : undefined;
      this.notes = obj.notes ? obj.notes : undefined;
      this.family_notes = obj.family_notes ? obj.family_notes : undefined;
      this.internal_notes = obj.internal_notes ? obj.internal_notes : undefined;
      this.completed = (obj.completed !== undefined) ? obj.completed : undefined;
      this.confirmed = (obj.confirmed !== undefined) ? obj.confirmed : undefined;
      this.no_show = (obj.no_show !== undefined) ? obj.no_show : undefined;
      this.no_show_count = (obj.no_show_count === undefined) || (obj.no_show_count === null)
        ? undefined : obj.no_show_count;
      this.spot_id = obj.spot_id ? obj.spot_id.toString() : undefined;
      this.virtual = (obj.virtual === undefined) || (obj.virtual === null) ? undefined : obj.virtual;
      this.virtual_instructions = obj.virtual_instructions ? obj.virtual_instructions : undefined;
      this.duration = obj.duration || undefined;
      this.deleted_at = obj.deleted_at ? new Date(obj.deleted_at) : undefined;

      if (obj.center) {
        this.center = new Center();
        this.center.buildFromJSON(obj.center);
      }
      if (obj.child) {
        this.child = new Child();
        this.child.buildFromJSON(obj.child);
      }
      if (obj.parent) {
        this.parent = new Parent();
        this.parent.buildFromJSON(obj.parent);
      }
      if (obj.parent2) {
        this.parent2 = new Parent();
        this.parent2.buildFromJSON(obj.parent2);
      }
      if (obj.seat) {
        this.seat = new Seat();
        this.seat.buildFromJSON(obj.seat);
      }
    }
  }

  toString() {
    let result = this.tour_id ? this.tour_id : '';
    return result;
  }

  getId() {
    return this.tour_id;
  }

  setId(tour_id) {
    this.tour_id = tour_id ? tour_id.toString() : undefined;
  }

  getCenter() {
    return this.center;
  }

  setCenter(center) {
    this.center = center ? center.copy() : undefined;
  }

  getStartTime() {
    return this.start_time;
  }

  setStartTime(start_time) {
    this.start_time = start_time ? new Date(start_time) : undefined;
  }

  getEndTime() {
    return this.end_time;
  }

  setEndTime(end_time) {
    this.end_time = end_time ? new Date(end_time) : undefined;
  }

  getNotes() {
    return this.notes;
  }

  setNotes(notes) {
    this.notes = notes;
  }

  getFamilyNotes() {
    return this.family_notes;
  }

  setFamilyNotes(family_notes) {
    this.family_notes = family_notes;
  }

  getInternalNotes() {
    return this.internal_notes;
  }

  setInternalNotes(internal_notes) {
    this.internal_notes = internal_notes;
  }

  getCompleted() {
    return this.completed;
  }

  setCompleted(completed) {
    this.completed = completed;
  }

  getConfirmed() {
    return this.confirmed;
  }

  setConfirmed(confirmed) {
    this.confirmed = confirmed;
  }

  getNoShow() {
    return this.no_show;
  }

  setNoShow(no_show) {
    this.no_show = no_show;
  }

  getNoShowCount() {
    return this.no_show_count;
  }

  setNoShowCount(no_show_count) {
    this.no_show_count = no_show_count;
  }

  getParent() {
    return this.parent;
  }

  setParent(parent) {
    this.parent = (parent) ? parent.copy() : undefined;
  }

  getParent2() {
    return this.parent2;
  }

  setParent2(parent) {
    this.parent2 = (parent) ? parent.copy() : undefined;
  }

  getChild() {
    return this.child;
  }

  setChild(child) {
    this.child = (child) ? child.copy() : undefined;
  }

  getVirtual() {
    return this.virtual;
  }

  setVirtual(virtual) {
    this.virtual = virtual;
  }

  getVirtualInstructions() {
    return this.virtual_instructions;
  }

  setVirtualInstructions(virtual_instructions) {
    this.virtual_instructions = virtual_instructions;
  }

  getDuration() {
    return this.duration;
  }

  setDuration(duration) {
    this.duration = duration;
  }

  getDeletedAt() {
    return this.deleted_at;
  }

  // Derived (read only)
  getSpotId() {
    return this.spot_id;
  }

  getSeat() {
    return this.seat;
  }
}

module.exports = Tour;
